// import { mapState } from 'vuex';

export default {
    computed: {
        email() {
            return this.$store.state.guests.email ||
                localStorage.getItem('guest_email') ||
                ''
        },
        phone() {
            return this.$store.state.guests.phone ||
                localStorage.getItem('guest_phone') ||
                ''
        },
        guestSetted() {
            return this.email.length > 0
        }
    },
    created() {
        if (this.$store.state.guests.email === '' ||
            this.$store.state.guests.phone === '') {
            this.setGuest(this.email, this.phone).catch(() => {
                // console.log(err)
            })
        }
    },
    methods: {
        setGuest(email = '', phone = '') {
            if (!email) {
                return new Promise((resolve, reject) => {
                    reject('No email provided')
                })
            }

            this.$emit('guestSetted')

            return Promise.all([
                this.$store.dispatch('guests/setEmail', email),
                this.$store.dispatch('guests/setPhone', phone)
            ]);
        }
    }
}